import React, { memo } from 'react';
var Graticule = memo(function (_a) {
    var draw = _a.draw, graticule = _a.graticule, stroke = _a.stroke;
    return (React.createElement("path", { pointerEvents: "none", fill: "none", strokeWidth: "0.5", stroke: stroke, d: draw(graticule()) }));
});
Graticule.displayName = 'Graticule';
export default Graticule;
